export const FLAG_KEYS = {
  // Flag to control the default onboarding flow for sign-up
  DEFAULT_ONBOARDING_SIGN_UP: 'uto-release-od-default-onboarding-to-sign-up',
  // Flag to control new theming
  APPLY_NEW_THEMING: 'uto-release-apply-new-theming-configuration',
  // Flag to control the sign-in flow on OD inside HPX
  SIGN_IN_ON_OD_FLOW_INSIDE_HPX:
    'uto-experiment-use-new-sign-in-on-od-flow-inside-hpx',
  // Flag to enable value proposition
  ENABLE_VALUE_PROPOSITION: 'uto-enable-value-proposition',
  // Flag to control if the app should use the FinishingSetupScreen loading or default to the circular loading
  ENABLE_USE_FINISHING_SETUP_SCREEN_LOADING:
    'uto-enable-use-finishing-setup-screen-loading'
};
